import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";

// import Login from "../../views/Login/Login";
// import Signup from "../../views/Signup/Signup";
// Auth Users
import Dashboard from "../../views/Dashboard/Dashboard";
import Tracking from "../../views/TrackingAccessPath/Tracking";
import Locklist from "../../views/Locklist/Locklist";
import ShareHistory from "../../views/ShareHistory/index";
import AuditTrail from "../../views/AuditTrail/AuditTrail";
import AccountManagement from "../../views/AccountManagement/AccountManagement";
import GroupManagementNew from "../../views/GroupManagementNew/GroupManagementNew";
import GroupManagement from "../../views/GroupManagement/GroupManagement";
import GrantAccess from "../../views/GrantAccess/GrantAccess";
// import GroupShare from "../../views/GroupSharing/index";
import UserManagement from "../../views/UserManagement/UserManagement";
import RecipientManagement from "../../views/RecipientManagement/index";
import MemberManagement from "../../views/MemberManagement/MemberManagement";
import RetractableAccess from "../../views/RetractableAccess/retractable";
import PageNotFound from "../../views/Errors/404Error";
import AuditTrailMapView from "../../views/AuditTrailMapview/MapView";
import Plans from "../../views/Plans/Plans";
import CustomPlans from "../../views/Plans/CustomPlan";
import MapAudit from "../../views/MapAudit/MapAudit";
import TagManagement from "../../views/TagManagement/TagManagement";
import LockScheduling from "../../views/LockScheduling/LockScheduling";
import Feedback from "../../views/Feedback/Feedback";
import Tutorial from "../../views/Tutorial/Tutorial";
// import SuperMultiApprove from "../../views/MultiApproveManagement/SuperMultiApprove";
import MultiApprove from "../../views/MultiApproveManagement/MultiApprove";
import ContactUs from "../../views/ContactUs/ContactUs";
import Setting from "../../views/SettingManagement/setting";
import Logs from "../../views/Logs/Logs";
import Chatbot from "../../views/Chatbot/Chatbot";
import { customLog } from "../../variables/Variables";
import CustomPlanPage from "../../views/Plans/CustomPlan";
//currentplan 9 can customplan


import ChatBot from 'react-simple-chatbot';
export class SuperAdminRoutes extends Component {
  componentWillMount() {
    customLog("Super Admin Route running !");
  }
  render() {
    return (
      <div>
      <Switch>
        //! ACTIVE ROUTES //! LIVE ROUTES
        <Route exact path="/tutorial" component={Tutorial} />
        <Route exact path="/dashboard" component={Dashboard} />
        {/* <Route exact path="/Tracking" component={Tracking} /> */}
        <Route exact path="/" component={Dashboard} />
        <Route exact path="/locklist" component={Locklist} />
        <Route exact path="/userManagement" component={UserManagement} />
        <Route exact path="/GrantAccess" component={GrantAccess} />
        <Route exact path="/multiApprove" component={MultiApprove} />
        <Route exact path="/RetractableAccess" component={RetractableAccess} />
        <Route exact path="/audittrail" component={AuditTrail} />
        <Route exact path="/accountManagement" component={AccountManagement} />
        <Route exact path="/plans" component={Plans} />
        <Route exact path="/contactUs" component={ContactUs} />
        <Route exact path="/setting" component={Setting} />
        <Route exact path="/logs" component={Logs} />
        {/* <Route exact path="/chatbot" component={Chatbot} />   */}
        <Route exact path="/customplan/hqa2ty3" component={CustomPlanPage} />
        {/*  */}
        //! FOR TESTING (COMMENT OUT WHEN PUSHING TO LIVE)
        {/* <Route
          exact
          path="/groupManagementNew"
          component={GroupManagementNew}
        /> */}
        {/* <Route exact path="/groupManagement" component={GroupManagementNew} /> */}
        {/*  */}
        //! INACTIVE ROUTES
        {/* <Route exact path="/test" component={Test} /> */}
        {/* <Route
          exact
          path="/RecipientManagement"
          component={RecipientManagement}
        /> */}
        {/* <Route exact path="/ShareHistory" component={ShareHistory} /> */}
        {/* <Route exact path="/memberManagement" component={MemberManagement} /> */}
        {/* <Route exact path="/groupManagement" component={GroupManagement} /> */}
        {/* <Route exact path="/audittrailmapview" component={AuditTrailMapView} /> */}
        {/* <Route exact path="/audittrailmapview" component={AuditTrailMapView} /> */}
        {/* <Route exact path="/mapaudit" component={MapAudit} /> */}
        {/* <Route exact path="/tagmanagement" component={TagManagement} /> */}
        {/* <Route exact path="/feedback" component={Feedback} /> */}
        {/* <Route exact path="/superMultiApprove" component={SuperMultiApprove} /> */}
        {/* <Route exact path="/lockscheduling" component={LockScheduling} /> */}
        {/* <Route exact path="/login" component={Login} />
        <Route exact path="/signup" component={Signup} /> */}
        {/* <Route exact path="/GroupSharing" component={GroupShare} /> */}
        
  
        {/*  */}
        //!DO NOT COMMENT OUT - MUST BE LAST
        <Route component={PageNotFound} />
      </Switch>
      {/* <Chatbot/> */}
      </div>
    );
  }
}

export default SuperAdminRoutes;